import { invokeRPC } from './socket.js'

export function createRssFeed(data) {
  return invokeRPC('rssFeeds', 'createRssFeed', data)
}

export function updateRssFeed(data) {
  return invokeRPC('rssFeeds', 'updateRssFeed', data)
}

export function getRssFeed(customerId) {
  return invokeRPC('rssFeeds', 'getRssFeed', { customer_id: customerId })
}